<template>
    <a-range-picker
        :get-calendar-container="getPopupContainer"
        :value="dateArray"
        :value-format="dateFormat"
        :format="dateFormat"
        :disabled-date="disabledDate"
        @update:value="onUpdateValue"
    />
</template>

<script>
import {computed} from "vue";
import moment from "moment";

export default {
    name: "RangePicker",
    emits: [
        "update:value",
        "update:startDate",
        "update:endDate"
    ],
    props: {
        startDate: {
            type: String,
            default: null,
        },
        endDate: {
            type: String,
            default: null,
        },
        start: {
            type: String,
            default: null,
        },
        end: {
            type: String,
            default: null,
        },
    },
    setup(props, {emit}) {
        const dateArray = computed(() => [props.startDate, props.endDate]);
        const disabledDate = (current) => {
            const beforeStartDate = props.start
                ? current.isBefore(moment(props.start).startOf("day"))
                : null;
            const afterEndDate = props.end
                ? current.isAfter(moment(props.end).endOf("day"))
                : null;
            return beforeStartDate || afterEndDate;
        };
        const onUpdateValue = (date) => {
            emit("update:value", date);
            emit("update:startDate", date[0]);
            emit("update:endDate", date[1]);
        };
        return {
            dateArray,
            dateFormat: "YYYY-MM-DD",
            disabledDate,
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
:deep(.ant-input){
    text-align: center;
    padding:4px 5px;
}
</style>
